import PropTypes from 'prop-types';
export const checkboxPropTypes = {
  /**
   * Field name value as string
   */
  name: PropTypes.string.isRequired,
  /**
   * Boolean value if field is required
   */
  required: PropTypes.bool,
  /**
   * Additional classname
   */
  classname: PropTypes.string,
  /**
   * Field value as string
   */
  value: PropTypes.string
};